<template>
  <div id="sideBar">
    <avator><img slot="img" src="~assets/img/avator.jpg" alt="" /></avator>
    <ul>
      <side-bar-item
        path="/new"
        svgHref="#icon-huaban"
        todoWord="首页"
      ></side-bar-item>
      <side-bar-item
        path="/myday"
        svgHref="#icon-A"
        todoWord="我的一天"
      ></side-bar-item>
      <side-bar-item
        path="/todo"
        svgHref="#icon-daiban1"
        todoWord="待完成任务"
      ></side-bar-item>
      <side-bar-item
        path="/read"
        svgHref="#icon-yuedu"
        todoWord="阅读"
      ></side-bar-item>
      <side-bar-item
        path="/movie"
        svgHref="#icon-dianying"
        todoWord="电影"
      ></side-bar-item>
      <!--         <li>
          <svg class="icon" aria-hidden="true"><use xlink:href="#icon-A"></use></svg>
          <a href="">我的一天</a>
        </li>
        <li>
          <svg class="icon" aria-hidden="true"><use xlink:href="#icon-daiban1"></use></svg>
          <a href="">待完成任务</a
            ></li>
        <li>
          <svg class="icon" aria-hidden="true"><use xlink:href="#icon-yuedu"></use></svg>
          <a href="">阅读</a>
        </li>
        <li><svg class="icon" aria-hidden="true"><use xlink:href="#icon-dianying"></use></svg>
          <a href="">电影</a>
        </li> -->
    </ul>
  </div>
</template>

<script>
import SideBarItem from "../sidebarItem/SideBarItem.vue";
import Avator from "components/content/avator/Avator.vue";
export default {
  name: "SideBar",
  components: {
    SideBarItem,
    Avator,
  },
};
</script>

<style scoped lang="less">
#sideBar {
  height: 90vh;
  width: 2.5rem;
  border: @main-border;

  border-radius: 0.28125rem;
  background: @sideBar-bgc;
  box-shadow: @box-shadow;

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.3rem;
  ul {
    padding: 0;
  }
}
</style>